// extracted by mini-css-extract-plugin
module.exports = {"container":"footbar_container__5RZPM"};